import {type Ref, shallowRef, watch} from 'vue'
import {liveQuery} from 'dexie'
import {useObservable} from "@vueuse/rxjs";
import {db} from '@src/services/db'
import {from} from 'rxjs'
import Group from "@src/types/Group";

export function useGroups() {
    function getGroups(term: Ref<string>) {
        const groups = shallowRef<Group[]>([])
        let subscription: any

        const runQuery = (value: string) => {
            subscription?.unsubscribe()

            subscription = from(
                liveQuery(async () => {
                    const cleanTerm = value.trim()

                    if (!cleanTerm) {
                        return db.groups
                            .orderBy('last_message_date')
                            .reverse()
                            .toArray()
                    }

                    const results = await db.groups
                        .where('name')
                        .startsWithIgnoreCase(cleanTerm)
                        .sortBy('last_message_date')

                    return results.reverse()
                })
            ).subscribe(result => {
                groups.value = result
            })
        }

        watch(
            term,
            (value) => runQuery(value),
            { immediate: true }
        )

        return groups
    }

    function getTotalUnreadGroupCount() {
        return useObservable<number>(
            // @ts-ignore
            liveQuery(async () => {
                const groups = await db.groups.toArray()
                return groups.reduce((sum, g) => sum + (g.unread_count ?? 0), 0)
            }),
            { initialValue: 0 }
        )
    }

    return { getGroups, getTotalUnreadGroupCount }
}
